// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce #easycommerce_store_render .easycommerce-modal-input {
    width: 360px;
    border: 1px solid #dbdbdb;
    border-radius: 8px;
    padding: 11px;
    font-size: 14px;
    font-family: "Inter", sans-serif;
    line-height: 26px;
    color: #120350;
    transition: 0.3s all ease-in-out;
}
.easycommerce
    #easycommerce_store_render
    .easycommerce-modal-input::-moz-placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce
    #easycommerce_store_render
    .easycommerce-modal-input::placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce #easycommerce_store_render .easycommerce-modal-input:hover {
    border-color: var(--color-ec-secondary);
}
.easycommerce #easycommerce_store_render .easycommerce-modal-input:focus {
    border: 1px solid var(--color-ec-primary);
    outline: none;
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);
}
`, "",{"version":3,"sources":["webpack://./spa/admin/common/components/LicenseScreen/assets/style.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;IACd,gCAAgC;AACpC;AACA;;;IAGI,kCAAkC;AACtC;AAJA;;;IAGI,kCAAkC;AACtC;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,yCAAyC;IACzC,aAAa;IACb,oDAAoD;AACxD","sourcesContent":[".easycommerce #easycommerce_store_render .easycommerce-modal-input {\n    width: 360px;\n    border: 1px solid #dbdbdb;\n    border-radius: 8px;\n    padding: 11px;\n    font-size: 14px;\n    font-family: \"Inter\", sans-serif;\n    line-height: 26px;\n    color: #120350;\n    transition: 0.3s all ease-in-out;\n}\n.easycommerce\n    #easycommerce_store_render\n    .easycommerce-modal-input::placeholder {\n    color: var(--color-ec-placeholder);\n}\n.easycommerce #easycommerce_store_render .easycommerce-modal-input:hover {\n    border-color: var(--color-ec-secondary);\n}\n.easycommerce #easycommerce_store_render .easycommerce-modal-input:focus {\n    border: 1px solid var(--color-ec-primary);\n    outline: none;\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
